/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Verif_2Inputs */

const en_mk_loop_verif_2 = /** @type {(inputs: Mk_Loop_Verif_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Reviewer — an AI reviewer reads the diff and the evidence`)
};

const id_mk_loop_verif_2 = /** @type {(inputs: Mk_Loop_Verif_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilai Bystep — reviewer AI membaca diff dan bukti`)
};

/**
* | output |
* | --- |
* | "Bystep Reviewer — an AI reviewer reads the diff and the evidence" |
*
* @param {Mk_Loop_Verif_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_verif_2 = /** @type {((inputs?: Mk_Loop_Verif_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Verif_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_verif_2(inputs)
	return en_mk_loop_verif_2(inputs)
});